import React from 'react';

const MaleFemaleIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(7.000000, 6.000000)'>
        <path d='M3.5,0 C4.6045695,0 5.5,0.8954305 5.5,2 C5.5,3.1045695 4.6045695,4 3.5,4 C2.3954305,4 1.5,3.1045695 1.5,2 C1.5,0.8954305 2.3954305,0 3.5,0 M2,5 L5,5 C6.1045695,5 7,5.8954305 7,7 L7,12.5 L5.5,12.5 L5.5,20 L1.5,20 L1.5,12.5 L0,12.5 L0,7 C0,5.8954305 0.8954305,5 2,5 M12.5,0 C13.6045695,0 14.5,0.8954305 14.5,2 C14.5,3.1045695 13.6045695,4 12.5,4 C11.3954305,4 10.5,3.1045695 10.5,2 C10.5,0.8954305 11.3954305,0 12.5,0 M11,20 L11,14 L8,14 L10.59,6.41 C10.84,5.59 11.6,5 12.5,5 C13.4,5 14.16,5.59 14.41,6.41 L17,14 L14,14 L14,20 L11,20 Z' />
      </g>
    </g>
  </svg>
);

export default MaleFemaleIcon;
